
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { diagnoseConnectionIssue, ConnectionTestResult } from "@/utils/supabaseConnectionTest";

interface ErrorScreenProps {
  authError: string;
  connectionStatus?: ConnectionTestResult | null;
  onRetry: () => void;
}

export const ErrorScreen = ({ authError, connectionStatus, onRetry }: ErrorScreenProps) => {
  console.log("=== SHOWING AUTH ERROR ===");
  console.log("Auth error detected:", authError);

  return (
    <div className="min-h-screen bg-gradient-to-br from-bg-gradient-from to-bg-gradient-to flex items-center justify-center p-4">
      <div className="text-center bg-white p-6 rounded-lg shadow-lg max-w-md">
        <h2 className="text-xl font-bold text-red-600 mb-4">Connection Error</h2>
        <p className="text-gray-600 mb-4">
          {connectionStatus ? diagnoseConnectionIssue(connectionStatus) : "We're having trouble connecting to our servers. This might be a temporary issue."}
        </p>
        <div className="space-y-2">
          <Button onClick={onRetry} className="w-full">
            <RefreshCw className="mr-2 h-4 w-4" />
            Retry Connection
          </Button>
        </div>
        {connectionStatus && (
          <div className="mt-4 text-xs text-gray-500">
            <p>Last test: {connectionStatus.details?.timestamp}</p>
            {connectionStatus.latency && <p>Latency: {connectionStatus.latency}ms</p>}
          </div>
        )}
      </div>
    </div>
  );
};
